import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import React ,{Component} from 'react';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import {NavLink, Navigate  } from 'react-router-dom';
import axios from 'axios';
import IconButton from '@mui/material/IconButton';


import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
//import { styled } from '@mui/material/styles';
import { styled } from '@mui/system';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export default class Addcompany extends Component {
constructor(props) {
    super(props);
	
	 this.state = {cmpid:'',open:false,data:[],redirect: false,details:'',btndisabled:false,submitbtn:"Submit",
countrydata:[],logredirect:false,pagename:'',countryid:"",countrylabel:'Select Country',city:"",name:"",emailid:"",phone:"",address1:"",address2:"",website:"",states:"",pin:"",
submitbtn:"Submit" ,cmp_members:'', statedata:[],statelabel:'Select Province',statename:''
      }
   
}


countrybind(){

    axios.get(localStorage.getItem("ISIurl")+'ajaxcountry.php?action=getall')
	
    
      .then((resp) => {    
     

	  
	  
	  let CountryApi = resp.data.map(row => {
                      
          return {value: row.co_id, display:row.co_name}
        });
		
		 this.setState({
          countrydata: [{value: '', display:'Select Country'}].concat(CountryApi)
        });
      }).then(data => {
		 
        
      
		
       
      })


   
	  
}

myChangeHandler = (event) => {
 
   const re = /^[0-9\.]+$/;
  let nam = event.target.name;
  let val = event.target.value;
  if(nam==="phone" || nam==="cmp_members")
  {
	  if (event.target.value === '' || re.test(event.target.value)) {
	  this.setState({[nam]: val}); 
  }
  }
  else if(nam==="countryid")
  {
	   this.setState({[nam]: val,statename:'',},()=>{this.statebind();});
  
  
  }
   else if(nam==="states")
  {
const selectedStateId = val;

const selectedState = this.state.statedata.find(
    state => state.value == selectedStateId
  );

	   this.setState({[nam]: val,statename: selectedState ? selectedState.display : ''
	
	   },()=>{this.OnchangestateSel();});
  
  
  }
  else{
	  
	   this.setState({[nam]: val});
  }
 
  
}
handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }

 getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}






componentWillMount () {
	document.title = "Isifol - Manage Company"; 

	 this.props.parentdasCallback(
            "Manage Company~"
        );
		  
		   let search = window.location.href;
	 let Compid = this.getParameterByName('cmpid',search);
	if(Compid!==null)
 {
	 axios.get(localStorage.getItem("ISIurl")+'ajaxcompany.php?action=getall&cmp_id='+Compid)
  .then(resp => {  
		
    if(resp.data.length>0){
		
		const selectedStatename = resp.data[0].cmp_state;


			this.setState({  
		cmpid:resp.data[0].cmp_id,
		names:resp.data[0].cmp_name,
		address1:resp.data[0].cmp_address1,
		address2:resp.data[0].cmp_address2,
		city:resp.data[0].cmp_city,
		statename:resp.data[0].cmp_state,
		
		pin:resp.data[0].cmp_pincode,
		countryid:resp.data[0].cmp_co_id,
		website:resp.data[0].cmp_website,
		phone:resp.data[0].cmp_phone,
		email:resp.data[0].cmp_email,
		
       cmp_members:resp.data[0].cmp_members,
			 	  
			  
			},()=>{
			
				 this.statebind();
			});
	}

  });
 		
 }	
this.countrybind();	
}




statebind(){

    axios.get(localStorage.getItem("ISIurl")+'ajaxlocation.php?action=getall&lo_co_id='+this.state.countryid)
	
    
      .then((resp) => {     
	  let StateApi = resp.data.map(row => {
                      
          return {value:row.lo_id, display:row.lo_state}
        });
		
		 this.setState({
          statedata: [{value:'', display:'Select State'}].concat(StateApi)
        },()=>{
			
			
			if(this.state.statename!=="")
	{
const selectedState = this.state.statedata.find(
    state => state.display == this.state.statename
  );
   this.setState({states:selectedState.value,});
	}
			
		});
	
      }).then(data => {
		 
        
      })

}


OnchangestateSel(){

    axios.get(localStorage.getItem("ISIurl")+'ajaxlocation.php?action=getall&lo_id='+this.state.states)
	
    
      .then((resp) => {     

		
		 this.setState({
           city:resp.data[0].lo_city,
	   pin:resp.data[0].lo_pincode,
        });
	

      }).then(data => {
		 
        
      })

}
  handleSubmit= (event) => {
	

    event.preventDefault();
	
	let names=this.state.names;
	let address1=this.state.address1;
	let address2=this.state.address2;
	let city=this.state.city;
	let states=this.state.statename;
	let pin=this.state.pin;
	let countryid=this.state.countryid;
	let website = this.state.website;
	let phone = this.state.phone;
    let email = this.state.email;

let cmp_members = this.state.cmp_members;
 const remail= /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
if(names==="")
{
	this.setState({errormessage:"Please Enter Name",erropen:true});
	return false;
	window.scrollTo({  top: 0,  behavior: 'smooth'});
}

if(email==="")
{
	this.setState({errormessage:"Please Enter Email",erropen:true});
	return false;
	window.scrollTo({  top: 0,  behavior: 'smooth'});
}else{
	
	 if (!remail.test(email)) {
	 this.setState({errormessage:"Please Enter Valid Email Id",erropen:true});		
	return false; 
	window.scrollTo({  top: 0,  behavior: 'smooth'});
  }
}
if(phone==="")
{
	this.setState({errormessage:"Please Enter Mobile No.",erropen:true});
	return false;
	window.scrollTo({  top: 0,  behavior: 'smooth'});
}if(city==="")
{
	this.setState({errormessage:"Please Enter City",erropen:true});
	return false;
	window.scrollTo({  top: 0,  behavior: 'smooth'});
}
 if(pin==="")
{
	this.setState({errormessage:"Please Enter Zipcode",erropen:true});
	return false;
	window.scrollTo({  top: 0,  behavior: 'smooth'});
}
 if(states==="")
{
	this.setState({errormessage:"Please Enter Province",erropen:true});
	return false;
	window.scrollTo({  top: 0,  behavior: 'smooth'});
}


if(countryid==="")
{
	this.setState({errormessage:"Please Enter Country",erropen:true});
	return false;
	window.scrollTo({  top: 0,  behavior: 'smooth'});
} 	
if(website==="")
{
	this.setState({errormessage:"Please Enter Website",erropen:true});
	return false;
	window.scrollTo({  top: 0,  behavior: 'smooth'});
} 
if(cmp_members==="")
{
	this.setState({errormessage:"Please Enter No. of Members.",erropen:true});
	return false;
	window.scrollTo({  top: 0,  behavior: 'smooth'});
} 
 if(address1==="")
{
	this.setState({errormessage:"Please Enter Address 1",erropen:true});
	return false;
	window.scrollTo({  top: 0,  behavior: 'smooth'});
}
 if(address2==="")
{
	this.setState({errormessage:"Please Enter Address 2",erropen:true});
	return false;
	window.scrollTo({  top: 0,  behavior: 'smooth'});
}
 

this.setState({btndisabled:true,submitbtn:"Processing..."})
	 var formData = new FormData();

	  
	 if(this.state.cmpid!=="")
	 {
	  
	  formData.append('cmp_id',this.state.cmpid)
	 }else
	 {
		formData.append('cmp_id',0)  
	 }
	 formData.append('action','insertorupdate')
    formData.append('cmp_name',names)
	 formData.append('cmp_address1',address1)
	 formData.append('cmp_address2',address2)
	 formData.append('cmp_city',city)
	 formData.append('cmp_state',states)
	 formData.append('cmp_pincode',pin)
	  formData.append('cmp_co_id',countryid)
	 formData.append('cmp_website',website)
	 formData.append('cmp_phone',phone)
    formData.append('cmp_email',email)
  formData.append('cmp_members',cmp_members)
	  		
	  formData.append('userid',localStorage.getItem("ISIuserid"))
	  
	 axios.post(localStorage.getItem("ISIurl")+"ajaxcompany.php", formData, {
        }).then(res => {
							if(res.data == -1)
{ 
		this.setState({errormessage:"Company Already Exist.",erropen:true,open:true,btndisabled:false,
submitbtn:"Submit",
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}else{
			
			this.setState({btndisabled:false,submitbtn:"Submit",logredirect: true, pagename:'/AdminCompany'});
    }
	});    
  };

  render() { 
  
  if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    }

  
  return (
 
		<React.Fragment>
	 <p style={{textAlign:'right'}}>
	<a href="#/AdminCompany" >
		<Button variant="contained"  className="frmSecondarybtn" >
			 Back
		</Button></a>
       
	
	</p>



  <p>   <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
           
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
    
 
	
<div className="customerform">

<ul>
  
<li>  
		  <p className="popformtext">Name: <span className="validation">*</span></p>
		 
		<p className="popforminputs">
		<TextField name="names" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.names}
			 
			  ref={this.usernameInput}
			inputProps={{tabIndex: "2",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
 
 </li>
 
 
  <li>	  <p className="popformtext">Email: <span className="validation">*</span></p>
		  
		  <p className="popforminputs"> 
		  <TextField name="email" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   
	   value={this.state.email}
		
			  ref={this.usernameInput}
			 inputProps={{tabIndex: "3",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          />
		  
		 
		  </p></li>		

 <li>	  <p className="popformtext">Mobile No.: <span className="validation">*</span></p>
		  
		  <p className="popforminputs"> 
		  <TextField name="phone" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   
	   value={this.state.phone}
		
			  ref={this.usernameInput}
			 inputProps={{tabIndex: "4",maxLength:15}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          />
		  
		 
		  </p></li> 		  
	
  <li>	  <p className="popformtext">Website: <span className="validation">*</span></p>
		  
		  <p className="popforminputs"> 
		  <TextField name="website" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   
	   value={this.state.website}
		
			  ref={this.usernameInput}
			 inputProps={{tabIndex: "7",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          />
		  
		 
		  </p></li>
			 	 
  
 <li>
		  <p className="popformtext">Country:</p>
		  <p className="popforminputs"><FormControl  className="stadrp">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.countrylabel, value: this.state.countryid}}
          onChange={this.myChangeHandler}
          id="countryid"
		   value={this.state.countryid} className="txtbox"
		  name="countryid"
		inputProps={{tabIndex: "8"}}
		
        >
		{this.state.countrydata.map(con => (
            <option  
            key={con.value}
              value={con.value}
            >
              {con.display}
            </option  >
          ))}
		
        </Select></FormControl>
		</p>
		  </li>
		  <li>  <p className="popformtext">Province: <span className="validation">*</span></p>
		  
		  <p className="popforminputs"> 
		  
		  
		  <FormControl   style={{"width":"100%"}}>
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.stateslabel, value: this.state.states}}
          onChange={this.myChangeHandler}
          id="states"
		   value={this.state.states}
inputProps={{tabIndex: "11",maxLength:150}}		  
		  name="states"
		   className="txtbox"
		inputProps={{tabIndex: "9"}}
		
        >
		{this.state.statedata.map(states => (
            <option  
             key={states.value}
              value={states.value}
            >
              {states.display}
            </option  >
          ))}
		
        </Select></FormControl>
		 
		  
		 
		  </p></li> 
		  
		<li>	  <p className="popformtext">City: <span className="validation">*</span> </p>
		  
		  <p className="popforminputs"> 
		  <TextField name="city" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   
	   value={this.state.city}
		
			  ref={this.usernameInput}
			 inputProps={{tabIndex: "5",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          />
		  
		 
		  </p> </li>
		  <li>

		  	  <p className="popformtext">Zipcode: <span className="validation">*</span></p>
		  
		  <p className="popforminputs"> 
		  <TextField name="pin" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   
	   value={this.state.pin}
		
			  ref={this.usernameInput}
			 inputProps={{tabIndex: "6",maxLength:50}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          />
		  
		 
		  </p></li> 
		  
		
		  

		  
		 
		  
		  
			    
		  <li>	  <p className="popformtext">No. of Members: <span className="validation">*</span></p>
		  
		  <p className="popforminputs"> 
		  <TextField name="cmp_members" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   
	   value={this.state.cmp_members}
		
			  ref={this.usernameInput}
			 inputProps={{tabIndex: "10",maxLength:3}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          />
		  
		 
		  </p></li> 
		 <div className="clear"></div>
<li>  <p className="popformtext">Address 1: <span className="validation">*</span></p>
		<p className="popforminputs"> <TextField name="address1" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	      multiline
          rows={3}
	   value={this.state.address1}
			 
			  ref={this.usernameInput}
			 inputProps={{tabIndex: "11",maxLength:350}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p></li>

	  
	  
	  
	  
<li>	  <p className="popformtext"> Address 2: <span className="validation">*</span></p>
		  
		  <p className="popforminputs"> 
		  
		  
		 <TextField name="address2" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	      multiline
          rows={3}
	   value={this.state.address2}
			 
			  ref={this.usernameInput}
			inputProps={{tabIndex: "12",maxLength:350}} className="txtbox" 
	   InputLabelProps={{ shrink: true }}
                          />
		  </p></li>
 

</ul>
		

</div>
		
          <p className="savebtn"> 
		  <Button variant="contained" className="frmSecondarybtn" onClick={this.handleSubmit}>
    {this.state.submitbtn}
</Button></p>

<div className="clear"></div>
		 

 </React.Fragment>
  );
  }
}